import { render } from "./Disabled.vue?vue&type=template&id=e0c01186&scoped=true"
const script = {}

import "./Disabled.vue?vue&type=style&index=0&id=e0c01186&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0c01186"]])

export default __exports__